
var Model = require("../types/Model.js");

module.exports = new Model({
	name: "toosmall",
	_size: null,
	init: init,
	listeners: listeners,
	triggers: triggers
});

function init() {
	this._size = null;
	this.push(false);
}

function listeners() {
	return {
		"size:updated": recalculate,
	};
}

function triggers() {
	return {
		hide: hideWarning,
	};
}

function hideWarning() {
	this._size = false;
	this.push(false);
}


function recalculate(size) {
	var small = isSmall(size);
	if(small === this.data) return;
	if(this._size === false) return ;
	this._size = small;
	this.push(this._size);
}

function isSmall(size) {
	if(size.width < 1024) return true;
	if(size.height < 600) return true;
	return false;
}
